module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='		<div class="page page__devices">\n		<div class="l-reports">\n			<div class="reports__header"></div>\n			<ul class="reports__list">\n				<li>Power (mA)</li>\n				<li>Emergency power</li>\n				<li>Location</li>\n				<li>Motion</li>\n				<li>Casing</li>\n				<li>Temperature</li>\n				<li>Burning Hours</li>\n			</ul>\n			<div class="reports__body">\n				<div class="reports__body__inner">\n					<div class="reports__title"">Power settings by driver (mA)</div>\n					<div class="reports__options"><a class="m-btn m-btn--primary js-add" role="button">export</a></div>\n				</div>\n			</div>\n		</div>\n		</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/page-reports/list/templates/report-list.html
// module id = 457
// module chunks = 0